import React from 'react';
import TestComponent from '../Index';
import testService from 'ApiService/Student/testServices';

const Index = () => {
  const title = 'No Tests Assigned Yet.';
  const fetchDaily = async () => {
    return await testService.getDailyTests();
  };
  return <TestComponent fetchTests={fetchDaily} NoData={title} />;
};

export default Index;
